import { Tabs } from 'app/components/tabs';
import { type Profile } from 'app/network/profile';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { NeighbourTab, ProfileListingResults, ProfileNamespace } from './shared';
import { NeighbourOffers } from './neighbour-offers';
import { NeighbourRequests } from './neighbour-requests';
import { FrequentedPlaces } from './frequented-places';

export function NeighbourListings({
  frequentedPlaces,
  isLargeUI,
  ns,
  offers,
  onTabChange,
  ratings,
  requests,
  searchQuery,
  setSearchQuery,
  sharingPlacesEnabled,
  tab,
}: {
  frequentedPlaces: Profile['frequentedPlaces'];
  isLargeUI: boolean;
  ns: ProfileNamespace;
  offers: ProfileListingResults;
  onTabChange: (tab: NeighbourTab) => void;
  ratings: React.ReactElement;
  requests: ProfileListingResults;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  sharingPlacesEnabled: boolean;
  tab: NeighbourTab;
}) {
  const { t } = useTranslation();
  let content: React.ReactNode = ratings;
  if (tab === 'offers') {
    content = (
      <NeighbourOffers
        isLargeUI={isLargeUI}
        results={offers}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
    );
  } else if (tab === 'requests') {
    content = (
      <NeighbourRequests
        isLargeUI={isLargeUI}
        results={requests}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
    );
  } else if (tab === 'places') {
    content = sharingPlacesEnabled ? <FrequentedPlaces places={frequentedPlaces} /> : null;
  }
  const tabs = [
    { value: 'offers', label: t('tabs.offers', { ns }) },
    { value: 'requests', label: t('tabs.requests', { ns }) },
    { value: 'reviews', label: t('tabs.reviews', { ns }) },
    ...(sharingPlacesEnabled ? [{ value: 'places', label: t('tabs.places', { ns }) }] : []),
  ];
  return (
    <>
      <Tabs value={tab} tabs={tabs} onPress={(nextTab) => onTabChange(nextTab as NeighbourTab)} />
      {content}
    </>
  );
}
